React = require 'react'
createReactClass = require 'create-react-class'
PropTypes = require 'prop-types'
ReactBacon = require 'react-bacon'
R = require 'ramda'
cx = require 'classnames'
{ toMoney } = require '../../lib/utils'
feedbackStore = require 'stores/feedback'
Globalize = require 'globalize'

{ FormatMessage } = require 'react-globalize'

SvgIcon = require 'app/common/svg-icon'

cartName = (name) ->
  "#{name}'s Order"

findSomething = (prop, value) -> R.pipe(R.prop(prop), R.equals(value))
findSubject = (name) -> findSomething('name', name)

classOrHideIf = R.curry (className, hide) -> cx className, 'hidden': hide

Summary = createReactClass
  displayName: 'Summary'
  props:
    order: PropTypes.object.isRequired
    locale: PropTypes.object.isRequired

  renderTotals: (totals) ->
    if totals
      <CartTotals totals={@props.order.totals} locale={@props.locale}/>
    else
      null

  render: ->
    renderCarts = R.map renderCart(@props.locale, @props.order.customer.name, @props.order.carts.length > 1)

    <div className="summary-box">
      <div className="summary-details expanded">
        <table className="details" width="100%">
          <thead className="details-header">
            <tr>
              <th><FormatMessage>order.summary.item</FormatMessage></th>
              <th width="8%"><FormatMessage>order.summary.quantity</FormatMessage></th>
              <th width="12%"><FormatMessage>order.summary.price</FormatMessage></th>
              <th></th>
            </tr>
          </thead>

          { renderCarts @props.order.carts }
          { @renderTotals(@props.order.totals) }
        </table>
      </div>
    </div>

renderCart = R.curry (locale, orderOwner, isCollaboration, cart) ->
  allowRatings = !isCollaboration or (cart.member and orderOwner == cart.member.name)
  <Cart key={cart.uuid} cart={cart} allowRatings={allowRatings} locale={locale} isCollaboration={isCollaboration}/>

Cart = createReactClass
  displayName: 'cart'

  props:
    cart: PropTypes.object.isRequired
    allowRatings: PropTypes.bool.isRequired
    locale: PropTypes.object.isRequired
    isCollaboration: PropTypes.bool.isRequired

  mixins: [ ReactBacon.BaconMixin ]

  getInitialState: ->
    subjects: []

  componentDidMount: ->
    @plug feedbackStore.feedbackItemSubjects, 'subjects'

  renderTotals: (totals) ->
    hideIf = classOrHideIf('total')
    if totals
      [
        <tr key="subtotal" className="total">
          <td><FormatMessage>order.summary.subtotal</FormatMessage>:</td>
          <td></td>
          <td>{toMoney(totals.subtotal, @props.locale)}</td>
          <td></td>
        </tr>
      ,
        <tr key="discount" className={hideIf(totals.discount == 0.0)}>
          <td><FormatMessage>order.summary.discount</FormatMessage>:</td>
          <td></td>
          <td>{toMoney(totals.discount, @props.locale)}</td>
          <td></td>
        </tr>
      ,
        <tr key="tax" className={hideIf(totals.tax == 0)}>
          <td><FormatMessage>order.summary.tax</FormatMessage>:</td>
          <td></td>
          <td>{toMoney(totals.tax, @props.locale)}</td>
          <td></td>
        </tr>
      ,
        <tr key="tip" className={hideIf(totals.tip == 0.0)}>
          <td><FormatMessage>order.summary.tip</FormatMessage>:</td>
          <td></td>
          <td>{toMoney(totals.tip, @props.locale)}</td>
          <td></td>
        </tr>
      ,
        <tr key="total" className="total">
          <td><b><FormatMessage>order.summary.total</FormatMessage>:</b></td>
          <td></td>
          <td><b>{toMoney(totals.total_to_customer, @props.locale)}</b></td>
          <td></td>
        </tr>
      ]
    else
      null

  render: ->
    customerClass = cx 'hidden': !@props.cart.member.name or !@props.isCollaboration
    renderItems = R.map renderItem(@props.locale, @state.subjects, @props.allowRatings)
    cartTotal = if @props.cart.totals then @props.cart.totals.total_to_customer else 0.0
    cartTotalClass = cx hidden: !@props.cart.totals

    <tbody>
      <tr className={customerClass}>
        <td colSpan="5" className="client">
          {cartName(@props.cart.member.name)}
        </td>
      </tr>
      { R.flatten renderItems @props.cart.items }
      { @renderTotals(@props.cart.totals) }
    </tbody>

CartTotals = createReactClass
  displayName: 'cart-totals'

  props:
    totals: PropTypes.object.isRequired
    locale: PropTypes.object.isRequired

  render: ->
    hideIf = classOrHideIf('total')

    <tfoot className="details-footer">
      <tr className="total">
        <td><FormatMessage>order.summary.subtotal</FormatMessage>:</td>
        <td></td>
        <td>{toMoney(@props.totals.subtotal, @props.locale)}</td>
        <td></td>
      </tr>
      <tr className={hideIf(@props.totals.discount == 0.0)}>
        <td><FormatMessage>order.summary.discount</FormatMessage>:</td>
        <td></td>
        <td>{toMoney(@props.totals.discount, @props.locale)}</td>
        <td></td>
      </tr>
      <tr className={hideIf(@props.totals.tax == 0.0)}>
        <td><FormatMessage>order.summary.tax</FormatMessage>:</td>
        <td></td>
        <td>{toMoney(@props.totals.tax, @props.locale)}</td>
        <td></td>
      </tr>
      { renderServiceCharges(@props.locale, @props.totals) }
      <tr className={hideIf(@props.totals.charges.hidden == 0.0)}>
        <td><FormatMessage>order.summary.service_charge</FormatMessage>:</td>
        <td></td>
        <td>{toMoney(@props.totals.charges.hidden, @props.locale)}</td>
        <td></td>
      </tr>
      <tr className={hideIf(@props.totals.charges.delivery == 0.0)}>
        <td><FormatMessage>order.summary.delivery_charge</FormatMessage>:</td>
        <td></td>
        <td>{toMoney(@props.totals.charges.delivery, @props.locale)}</td>
        <td></td>
      </tr>
      <tr className={hideIf(@props.totals.tip == 0.0)}>
        <td><FormatMessage>order.summary.tip</FormatMessage>:</td>
        <td></td>
        <td>{toMoney(@props.totals.tip, @props.locale)}</td>
        <td></td>
      </tr>
      <tr className="total">
        <td><b><FormatMessage>order.summary.total</FormatMessage>:</b></td>
        <td></td>
        <td><b>{toMoney(@props.totals.total_to_customer, @props.locale)}</b></td>
        <td></td>
      </tr>
    </tfoot>

renderServiceCharges = (locale, totals) ->
  if totals.detailed_charges && totals.detailed_charges.length > 0
    totals.detailed_charges.map(renderCharge(locale))
  else
    renderCharge(locale, {id: 'service', name: Globalize.formatMessage('order.summary.service_charge'), amount: totals.charges.service})

renderCharge = R.curry (locale, {id, name, amount}) ->
  if amount != 0.0
    <tr key={id} className="total">
      <td>{name}:</td>
      <td></td>
      <td>{toMoney(amount, locale)}</td>
      <td></td>
    </tr>

renderItem = R.curry (locale, subjects, allowRatings, item) ->
  subject = R.find findSubject(item.item_name), subjects
  rating = subject.rating if subject

  <CartItem key={item.id} item={item} subject={subject} allowRating={allowRatings} locale={locale}>
    <CartItemCustomizations item={item} groups={item.groups} locale={locale} />
  </CartItem>

CartItem = createReactClass
  displayName: 'cart-item'

  mixins: [ReactBacon.BaconMixin]

  props:
    item: PropTypes.object.isRequired
    subject: PropTypes.object.isRequired
    allowRating: PropTypes.bool.isRequired
    locale: PropTypes.object.isRequired

  getInitialState: ->
    session: null
    score: null

  componentDidMount: ->
    @plug feedbackStore.feedbackSession, 'session'

  rateItem: (score) ->
    # Act as toggle
    # score = null if @props.rating and @props.rating.score == score
    @setState score: score
    if @props.allowRating
      feedbackStore.rate @props.subject, score

  render: ->
    i = @props.item

    ratingScore = @state.score || R.path(['subject', 'rating', 'score'], @props)

    haveRating = !R.isNil(ratingScore) and ratingScore != 0
    haveRating or= @props.allowRating

    ratingClass = cx 'glyph-cell',
      'hidden': !haveRating || !@props.subject || !@state.session || @state.session.closed

    likeClass = cx 'active': ratingScore == 2
    dislikeClass = cx 'active': ratingScore == 1

    likeIt = R.partial @rateItem, [ 2 ]
    dislikeIt = R.partial @rateItem, [ 1 ]

    <tr>
      <td className="item-cell">
        <p><i>{i.category} - </i>{i.name}</p>
        {@props.children}
        { @renderComments(i) }
      </td>
      <td className="quantity" label={Globalize.formatMessage("order.summary.quantity") + ': '}>{i.quantity}</td>
      <td className="price" label={Globalize.formatMessage("order.summary.price") + ': '}>{toMoney(i.total, @props.locale)}</td>
      <td className={ratingClass}>
        <a className={likeClass} onClick={likeIt}><SvgIcon icon="thumb_up" size={24}/></a>
        <a className={dislikeClass} onClick={dislikeIt}><SvgIcon icon="thumb_down" size={24}/></a>
      </td>
    </tr>

  renderComments: (i) ->
    if i.comments
      <b style={fontSize: "13px"}>{i.comments}</b>

CartItemCustomizations = createReactClass
  displayName: 'cart-item-customisation'

  props:
    groups: PropTypes.object.isRequired
    locale: PropTypes.object.isRequired

  renderModifier: (group) ->
    modifier = R.curry (locale, modifier) ->
      qty = if modifier.quantity > 1 then "#{modifier.quantity} x" else ""
      if modifier.total > 0
        <span key={modifier.id}>{qty} { modifier.name } - { toMoney(modifier.total, locale) }</span>
      else
        <span key={modifier.id}>{"#{qty} #{modifier.name}"}</span>

    modifiers = R.intersperse ", ", R.map modifier(@props.locale), group.modifiers

    <p key={group.name}>
      <b>{group.name}</b> • {modifiers}
    </p>

  render: ->
    modifiers = R.map @renderModifier, @props.groups

    <div className="ingredients" key={@props.item.id}>
      { modifiers }
    </div>

module.exports = Summary
